"use client";

import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const IconStyle = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom?.socialIcon,
  borderRadius: 0,
  border: `1px solid ${theme.palette.custom?.socialIcon}`,
  width: "1.5rem",
  height: "1.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all ease-in-out .2s",
  gap: "1.2rem",
  "& > svg": {
    fontSize: "0.9rem",
  },
  "&:hover": {
    transition: "all ease-in-out .2s",
    color: theme.palette.custom?.socialIconHover,
    border: `1px solid ${theme.palette.custom?.socialIconHover}`,
  },
}));

export default IconStyle;
